<template>
  <div style="display: flex; flex-direction: column">
    <div style="display: flex; justify-content: space-between">
      <cargo-input v-model="job.consigneeCode" style="width:115px;margin-right: 5px;flex-grow: 1;" :placeholder="disabled ? '' : $t('SeaExport.ConsigneeId')" :auto-uppercase="autoUppercase" :disabled="disabled" @change="onChange('consigneeCode')" />
      <cargo-company-select
        :disabled="disabled"
        :method-params="{consignee:true,active:true}"
        :default-value="job.consigneeId||''"
        style="display: inline-block;width:145px;flex-grow: 1;"
        @change="consigneeChange"
      />
    </div>
    <cargo-input
      v-for="i in 7"
      :key="i"
      v-model="job['consigneeLine'+i]"
      :use-read-only="true"
      :disabled="disabled"
      :auto-uppercase="autoUppercase"
      style="margin-top: 5px"
      @change="onChange('consigneeLine'+i)"
    />
  </div>
</template>

<script>
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { Company } from '@/class/model/mdm/Company'

export default {
  name: 'AeVesselConsignee',
  components: { cargoInput, cargoCompanySelect },
  props: {
    job: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false },
    autoUppercase: { type: Boolean, default: false }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    },
    async consigneeChange(data) {
      const form = this.job
      form.consigneeId = data.value
      if (form.consigneeId) {
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          form.consigneeLine1 = manifestAddress.addressLine1
          form.consigneeLine2 = manifestAddress.addressLine2
          form.consigneeLine3 = manifestAddress.addressLine3
          form.consigneeLine4 = manifestAddress.addressLine4
          form.consigneeLine5 = manifestAddress.addressLine5
          form.consigneeLine6 = manifestAddress.addressLine6
          form.shipperLine7 = manifestAddress.addressLine7
        } else {
          form.consigneeLine1 = ''
          form.consigneeLine2 = ''
          form.consigneeLine3 = ''
          form.consigneeLine4 = ''
          form.consigneeLine5 = ''
          form.consigneeLine6 = ''
          form.consigneeLine7 = ''
        }
      }
      const items = []
      items.push({ key: 'consigneeId', value: form.consigneeId })
      for (let i = 1; i <= 7; i++) {
        items.push({ key: `consigneeLine${i}`, value: form[`consigneeLine${i}`] })
      }
      this.$emit('childrenChange', items)
    }
  }
}
</script>
